import _ from 'lodash';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Table, FormCheck } from 'react-bootstrap';
import Widgets from './index';
import { updateUserData } from '../../actions/AppActions';
import Auth from '../../services/AuthService';

const WidgetManager = () => {
  const dispatch = useDispatch();
  const userWidgets = useSelector(state => state.app.userData.widgets) || [];

  const showHideWidget = (widgetName, show) => {
    dispatch(updateUserData(`widgets.${widgetName}`, { show: !show }));
  };

  const widgets = _.defaultsDeep(userWidgets, Widgets);

  const widgetList = Object.keys(widgets).map(name => {
    const { title, description, permissions, show } = widgets[name];

    if (!Auth.hasPermissionToMany(permissions)) {
      return null;
    }

    if (name === 'menu') {
      // can't handle this yet
      return null;
    }

    return (
      <tr key={`widget-list-${name}`}>
        <td>
          <FormCheck checked={show} onChange={() => showHideWidget(name, show)} label="" />
        </td>
        <td>{description || title}</td>
      </tr>
    );
  });

  return (
    <Table responsive style={{ width: '100%' }}>
      <thead>
        <tr>
          <th>Show</th>
          <th>Widget</th>
        </tr>
      </thead>
      <tbody>{widgetList}</tbody>
    </Table>
  );
};

export default WidgetManager;
